import React from 'react'
import { QuestionFrame, YesNoQuestion } from 'components/questions'


export const Q12 = () => {

  return (
    <QuestionFrame q={12}>
      <YesNoQuestion num={1} content={'建物外からの逆流の恐れがない雨水貯留槽はありますか。'} />
    </QuestionFrame>
  )
}
